(function (angular) {
    'use strict';

    angular.module('broadcast')

        /**
         *
         */
        .factory('broadcastSharedService',
            ["sharedDataService", "audiencesService", "$state", "$stateParams", "$uibModal", "utilService", "broadcastService", "growlService", "whatsAppServices", "$q",
                function (sharedDataService, audiencesService, $state, $stateParams, $uibModal, utilService, broadcastService, growlService, whatsAppServices, $q) {

                    function getUsername(username) {
                        return sharedDataService.getUsername(username);
                    };

                    function duplicateBroadcast(broadcast) {
                        utilService.removeEmpty(broadcast);

                        // give a new id ...
                        broadcast.id = utilService.uuid();

                        if (broadcast.to && broadcast.to.audiences[0]) {
                            //check if audience exist..
                            audiencesService.getAudiences($stateParams.pickedApiSpaceId)
                                .then(function (audiences) {
                                    var audience = audiences.find(
                                        function (el) {
                                            return el.id === broadcast.to.audiences[0];
                                        });
                                    if (!audience || audience.isTest) {
                                        delete broadcast.to;
                                    }
                                    return broadcastService.createBroadcast($stateParams.pickedApiSpaceId, broadcast);
                                })
                                .then(function (result) {
                                    $state.go("main.apiSpace.broadcastWizard", {
                                        pickedApiSpaceId: $stateParams.pickedApiSpaceId,
                                        broadcastId: broadcast.id,
                                    });
                                })
                                .catch(function (error) {
                                    console.error(error);
                                    growlService.danger("Broadcast duplication failed:" + error.statusText);
                                    return false;
                                });
                        }

                    }

                    function showBroadcastDetails(broadcast) {
                        var broadcastHistory = broadcast;
                        if (broadcast.broadcast) {
                            broadcast = broadcast.broadcast;
                        }
                        if (broadcast.to && broadcast.to.audiences[0]) {
                            var channel = broadcast.rules[0];
                            //check if audience exist..
                            audiencesService.getAudiences($stateParams.pickedApiSpaceId)
                                .then(function (audiences) {
                                    var audience = audiences.find(
                                        function (el) {
                                            return el.id === broadcast.to.audiences[0];
                                        }
                                    )
                                    if (audience) {
                                        var modalInstance = $uibModal.open({
                                            animation: true,
                                            size: 'lg',
                                            templateUrl: 'components/toolkit/broadcast/templates/broadcastDetails.html',
                                            controller: 'broadcastDetailsViewModal',
                                            resolve: {
                                                message: function () {
                                                    return broadcast;
                                                },
                                                channel: function () {
                                                    return channel;
                                                },
                                                audienceName: function () {
                                                    return audience.name;
                                                },
                                                sentBy: function () {
                                                    if (broadcastHistory.broadcast) {
                                                        return getUsername(broadcastHistory._createdBy);
                                                    }
                                                    return null;
                                                }
                                            }
                                        });

                                        modalInstance.result.then(function (data) {
                                        }, function (err) {
                                        });
                                    }
                                    else {
                                        openDetailsWithoutAudience(broadcast);
                                    }
                                })
                        }
                        else {
                            openDetailsWithoutAudience(broadcast);
                        }
                    };
                    function openDetailsWithoutAudience(broadcast) {
                        var modalInstance = $uibModal.open({
                            animation: true,
                            templateUrl: 'components/toolkit/broadcast/templates/broadcastDetails.html',
                            controller: 'broadcastDetailsViewModal',
                            resolve: {
                                message: function () {
                                    return broadcast;
                                },
                                audienceCount: function () {
                                    return null;
                                },
                                availableAudienceCount: function () {
                                    return null;
                                },
                                channel: function () {
                                    return null;
                                },
                                audienceName: function () {
                                    return null;
                                },
                                sentBy: function () {
                                    return null;
                                }
                            }
                        });
                        modalInstance.result.then(function (data) {
                        }, function () {
                        });
                    };
                    var fac = {
                        showBroadcastDetails: showBroadcastDetails,
                        getUsername: getUsername,
                        duplicateBroadcast: duplicateBroadcast
                    }
                    return fac;
                }
            ]
        )

})(window.angular);

